export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
} as const

export const API_DICTIONARY = {
  COMMUNITIES: 'communities/',
  USERS: 'users/',
  USER: 'user/',
  CURRENT: 'current/',
  HEALTH_SYSTEMS: 'health_systems/',
  HEALTH_SYSTEM: 'health_system/',
  AVAILABLE_HEALTH_SYSTEMS: 'available_health_systems/',
  HOSPITALS: 'hospitals/',
  PROMOTE: 'promote/',
  HOSPITAL: 'hospital/',
  HOSPITAL_USERS: 'hospital_users/',
  DEPARTMENTS: 'departments/',
  DEFAULT_DEPARTMENTS: 'default_departments/',
  DOCUMENTS: 'documents/',
  CONTRACT_CATEGORIES: 'contract_categories/',
  CATEGORIES: 'categories/',
  CONTRACT_CATEGORY: 'contract_category/',
  AUTH: 'auth/',
  RESET_PASSWORD: 'reset_password/',
  SIGN_IN: 'sign_in/',
  SIGN_UP: 'sign_up/',
  VENDORS: 'vendors/',
  REPOSITORY: 'repository/',
  MY_VENDORS: 'my_vendors/',
  VENDOR: 'vendor/',
  VENDORS_SHORT: 'vendors/short_info/',
  ACCEPTED_VENDORS: 'accepted_vendors/',
  RFP: 'rfp/',
  SURVEY: 'survey/',
  CREATION: 'creation/',
  BULK_ARCHIVE: 'bulk_archive/',
  BULK_CREATION: 'bulk_creation/',
  ITEMS: 'items/',
  RFP_VENDOR_USERS: 'rfp_vendor_users/',
  AVAILABLE_VENDOR_USERS: 'available_vendor_users/',
  TIMELINES: 'timelines/',
  MANUAL_CREATION: 'manual_creation/',
  ARCHIVE: 'archive/',
  FILES: 'files/',
  RFP_DEFAULT_DOCUMENTS: 'rfp_default_documents/',
  RFP_VENDOR_DOCUMENTS: 'rfp_vendor_documents/',
  VENDOR_BIDDING: 'vendor_bidding/',
  STAKEHOLDER_VOTE: 'stakeholder_vote/',
  RESPONSIBLE_USERS: 'responsible_users/',
  COMMONS_REASSIGNMENT: 'commons_reassignment/',
  CALENDARS: 'calendars/',
  SCHEDULE: 'schedule/',
  CONTRACTS: 'contracts/',
  PAYMENT_TERM_DAYS: 'payment_term_days/',
  PAYMENT_FREQUENCY: 'payment_frequency/',
  VERSION_HISTORY_DOCUMENTS: 'version_history_documents/',
  CONTRACT_DOCUMENT: 'contract_document/',
  CONTRACT_DOCUMENTS: 'contract_documents/',
  CONTRACT_ATTACHMENTS: 'contract_attachments/',
  CONTRACT_EXTENSION_DOCUMENTS: 'contract_extension_documents/',
  CONTRACTING_ITEMS: 'contracting_items/',
  REBATES: 'rebates/',
  REBATE: 'rebate/',
  TIERS: 'tiers/',
  PERIODS: 'periods/',
  CONTRACT_AMENDMENT_DOCUMENTS: 'contract_amendment_documents/',
  HS_AMENDMENT: 'hs_amendment/',
  DASHBOARD: 'dashboard/',
  SAVINGS_DASHBOARD: 'savings_dashboard/',
  COMMUNITY_ACCESS: 'community_access/',
  ADDITIONAL_VALUES: 'additional_values/',
  ONGOING_DASHBOARD: 'ongoing_dashboard/',
  COMPLIANCE_DASHBOARD: 'compliance_dashboard/',
  GROUPED_DATA: 'grouped_data/',
  SAVINGS_SUMMARY_TABLE: 'savings_summary_table/',
  OWNERS_REASSIGNMENT: 'owners_reassignment/',
  OWNER: 'owner/',
  SOURCING_SIDE: 'sourcing_side/',
  SOURCING_USERS: 'sourcing_users/',
  CHATS: 'chats/',
  UNREAD_COUNT: 'unread_count/',
  PVP_AVAILABLE_USERS: 'pvp_available_users/',
  GROUP_AVAILABLE_USERS: 'group_available_users/',
  VENDOR_CONTRACT_STEWARDS: 'vendor_contract_stewards/',
  AVAILABLE_OWNERS: 'available_owners/',
  MARK_AS_READ: 'mark_as_read/',
  PURCHASE_ORDER_TEMPLATE: 'purchase_order_temaplate/',
  INVOICE_DATA_TEMPLATE: 'invoice_data_template/',
  INVOICES: 'invoices/',
  PENDING_CLASSIFICATION: 'pending_classification/',
  SIMILAR_ITEMS: 'similar_items/',
  CLASSIFY: 'classify/',
  FINANCES: 'finances/',
  PURCHASE_ORDER: 'purchase_order/',
  PURCHASE_ORDERS: 'purchase_orders/',
  TOTAL_SPEND: 'total_spend/',
  TOTAL_SPEND_DATA: 'total_spend_data/',
  BULK_REMOVE: 'bulk_remove/',
  VOTING_PANEL_MEMBERSHIP: 'voting_panel_membership/',
  FINANCES_DASHBOARD: 'finances_dashboard/',
  CALCULATIONS: 'calculations/',
  REPORTS: 'reports/',
  ACTUAL_PAYMENTS: 'actual_payments/',
  RECALCULATION: 'recalculation/',
  REBATE_FEE: 'rebate_fee/',
  SHORT_INFO: 'short_info/',
  INFO: 'info/',
  FACILITIES: 'facilities/',
  FACILITY: 'facility/',
  CONFIRM_CREDS: 'confirm_creds/',
  CONFIRM_SMS_CODE: 'confirm_sms_code/',
  SET_PHONE_NUMBER: 'set_phone_number/',
  RESEND_SMS_CODE: 'resend_sms_code/',
  RESEND_INVITATION: 'resend_invitation/',
  SELF_SIGN_UP: 'self_sign_up/',
  RFP_VENDOR_TEAM: 'rfp_vendor_team/',
  PAYMENTS: 'payments/',
  MESSAGES: 'messages/',
  MEMBERS: 'members/',
  SUPPORT: 'support/',
  CONTACT_US: 'contact_us/',
  PRS: 'prs/',
  PDF: 'pdf/',
  AVAILABLE_COMMUNITY_RESPONSIBLES: 'available_community_responsibles/',
  PRS_REQUEST_ATTACHMENTS: 'prs_request_attachments/',
  PRS_REQUEST_IMAGES: 'prs_request_images/',
  UPDATE: 'update/',
  CLINICAL_SPONSOR_USERS: 'clinical_sponsor_users/',
  VOTE: 'vote/',
  FACILITY_USERS: 'facility_users/',
  AVAILABLE: 'available/',
  CLINICAL_SPONSOR_SURVEY: 'clinical_sponsor_survey/',
  AGGREGATED_RESULTS: 'aggregated_results/',
  USER_RESULTS: 'user_results/',
  VOTED_USERS: 'voted_users/',
  TRIAL: 'trial/',
  RESULTS: 'results/',
  RCA: 'rca/',
  NEXT_STEPS: 'next_steps/',
  RESPONSIBLE_USER_REASSIGNMENT: 'responsible_user_reassignment/',
  STAKEHOLDER_REVIEWS: 'stakeholder_reviews/',
  STATISTICS: 'statistics/',
  CONTRACT: 'contract/',
  CHANGE_LOGS: 'change_logs/',
  SEARCH: 'search/',
  CHAT_ATTACHMENTS: 'chat_attachments/',
  TIMERS: 'timers/',
  ANALYSIS: 'analysis/',
  EVALUATION: 'evaluation/',
  AVALIABLE_OPPORTUNITIES: 'avaliable_opportunities/',
  COMMONS: 'commons/',
  COMMONS_RESPONSIBLE: 'commons_responsible/',
  CONTRACT_GROUP: 'contract_group/',
  CONTACT_PERSONS: 'contact_persons/',
  ACCEPT: 'accept/',
  COMMUNITY_HEALTH_SYSTEMS: 'community_health_systems/',
  REQUESTS_FOR_ANALYSIS: 'requests_for_analysis/',
  CONTRACT_EVALUATION_DOCUMENTS: 'contract_evaluation_documents/',
  EVALUATION_PO_DOCUMENTS: 'evaluation_po_documents/',
  STAKEHOLDER_ASSIGNMENT: 'stakeholder_assignment/',
  STAKEHOLDER_REVIEW: 'stakeholder_review/',
  CONTRACT_GROUPS: 'contract_groups/',
  HEADER: 'header/',
  SAVINGS: 'savings/',
  TERMINATE: 'terminate/',
  CLINICAL_REVIEW_STATISTICS: 'clinical_review_statistics/',
  CLINICAL_REVIEW_STAKEHOLDERS: 'clinical_review_stakeholders/',
  SAVINGS_GOAL: 'savings_goal/',
  HISTORY: 'history/',
  TIMEZONES: 'timezones/',
  OPTIONS: 'options/',
  EVENT_TYPE: 'event_type/',
  AVAILABLE_PARTICIPANTS: 'available_participants/',
  RESPOND: 'respond/',
  PIPELINES: 'pipelines/',
  LED_BY: 'led_by/',
  OPT_OUT: 'optout/',
  JOIN: 'join/',
  RESPONSIBLES: 'responsibles/',
  RESPONSIBLE: 'responsible/',
  RESEND: 'resend/',
  REASON: 'reason/',
  NOTIFICATIONS: 'notifications/',
  MARK_ALL_AS_READ: 'mark_all_as_read/',
  DEVICES: 'devices/',
  BADGE_COUNT: 'badge_count/',
  DEPARTMENT: 'department/',
  VISITOR: 'visitor/',
  QR_CODE: 'qr_code/',
  MY_COMMUNITY: 'my_community/',
  ALLOWED_ROLES: 'allowed_roles/',
  SPEND_BY_MONTH: 'spend_by_month/',
  SPEND_BY_FACILITY: 'spend_by_facility/',
  SPEND_BY_CATEGORY: 'spend_by_category/',
  REBATE_TYPE: 'rebate_type/',
  GROUPS: 'groups/',
  CONTRACT_CATEGORY_APPROVAL: 'contract_category_approval/',
  CONTRACT_ITEMS_METADATA: 'contract_items_metadata/',
  CONTRACT_ITEMS: 'contract_items/',
  RECONCILIATION: 'reconciliation/',
  RESOLVE: 'resolve',
  AWAITING_APPROVAL: 'awaiting_approval/',
  PENDING: 'pending/',
  APPROVE: 'approve/',
  APPROVAL: 'approval/',
  SEND_FOR_APPROVAL: 'send_for_approval/',
  CC: 'cc/',
  SPEND_BY_VENDOR: 'spend_by_vendor/',
  NON_COMPLIANT_PRODUCTS: 'non_compliant_products/',
  REJECTED: 'rejected/',
  NON_PO: 'non_po/',
  COMPLETE: 'complete/',
  CONFIRM_EMAIL: 'confirm_email/',
  CREATOR: 'creator/',
  SHIP_TO_ENTITY_HOSPITAL: 'ship_to_entity_hospital/',
  DOWNLOAD: 'download/',
  STATUS: 'status/',
  UPLOAD: 'upload/',
  GENERATE_FILE: 'generate_file/',
  PAYMENT_BY_STATUS: 'payment_by_status/',
  CATEGORY: 'category/',
  SETUP: 'setup/',
  REBATES_DASHBOARD: 'rebates_dashboard/',
  UPDATE_LEVEL: 'update_level/',
  CREATE_RELATION: 'create_relation/',
  NATIONAL_GPO: 'national_gpo/',
  BUSINESS: 'business/',
  BUSINESSES: 'businesses/',
  TAX_ID_TYPE: 'tax_id_type/',
  COUNTRY: 'country/',
  STATE: 'state/',
  STATES: 'states/',
  ADDRESS_TYPE: 'address_type/',
  BANK_ACCOUNT: 'bank_account/',
  ACCOUNT_TYPE: 'account_type/',
  COMMUNITY: 'community/',
  ADMIN_SPLIT_FEE: 'admin_split_fee/',
  UNSET_CATEGORIES: 'unset_categories/',
  DISPUTE_TYPE: 'dispute_type/',
  FACILITY_REVIEW_STATUS: 'facility_review_status/',
  DISPUTE: 'dispute/',
  REPLY: 'reply/',
  SIGNATORY: 'signatory/',
  COMMUNITY_SIGNATORY: 'community_signatory/',
  VENDOR_SIGNATORY: 'vendor_signatory/',
  COGNUS_AR: 'cognusar/',
  MARKETPLACE_AR: 'marketplacear/',
  PAYMENT: 'payment/',
  TOKEN: 'token/',
  REFRESH: 'refresh/',
  ORGANIZATION: 'organization/',
  DOCUMENT_HISTORY: 'document_history/',
  REASSIGNMENT: 'reassignment/',
  PERIOD_THRESHOLD: 'period_threshold/',
  NOTES: 'notes/',
  NOTE: 'note/',
  GPO_RELATION: 'gpo_relation/',
  GPO: 'gpo/',
  ADMIN_SPLIT_FEES: 'admin_split_fees/',
  LED_BY_GPO: 'led_by_gpo/',
  LED_BY_COMMUNITY: 'led_by_community/',
  SPLIT_FEES: 'split_fees/',
  COMMUNITY_PROCESSING: 'community_processing/',
  ADMIN_FEE_DASHBOARD: 'admin_fee_dashboard/',
  COUNT: 'count/',
  VERIFY: 'verify/',
  ALTERNATE_NAME: 'alternate_name/',
  REMIT_ADVICE: 'remit_advice/',
  INVOICE: 'invoice/',
  VENDOR_FEE_TYPE: 'vendor_fee_type/',
  ASSIGN: 'assign/',
  OWNERS: 'owners/',
  CHECK_RELATED_ITEMS: 'check_related_items/',
  REASSIGN: 'reassign/',
  REASSIGNMENT_REQUESTS: 'reassignment_requests/',
  ACCOUNTS_PAYABLE: 'accounts_payable/',
  ACCOUNTS_RECEIVABLE: 'accounts_receivable/',
  ADMIN_FEES: 'admin_fees/',
  UNASSIGN: 'unassign/',
  DELETE: 'delete/',
  ORG_CONTRACT_CATEGORIES: 'org_contract_category/',
  PAYORS: 'payors/',
  TYPE: 'type/',
  SUBTYPE: 'subtype/',
  SOURCING_PERSON: 'sourcing_person/',
  SUMMARY: 'summary/',
  VENDOR_USERS: 'vendor_users/',
  CO_USERS: 'co_users/',
  MOOV: 'moov/',
  BUSINESS_ACCOUNT: 'business_account/',
  PORTFOLIO: 'portfolio/',
  NAME: 'name/',
  OAUTH: 'oauth/',
  ACCESS: 'access/',
  BANK_ACCOUNTS: 'bank_accounts/',
  UNDERWRITING: 'underwriting/',
  PENDING_CREATION: 'pending_creation/',
  BANK_ACCOUNT_STATUS: 'bank_account_status/',
  MICRO_DEPOSITS: 'micro_deposits/',
  ONBOARDING_SESSION: 'onboarding_session/',
  CONTINUE: 'continue/',
  SHIPPING_METHOD: 'shipping_method/',
  FILTERS: 'filters/',
  RESOLUTION_LINK: 'resolution_link/',
  PURPOSE: 'purpose/',
  DEFAULT: 'default/',
  REBATE_CORRELATION: 'rebate_correlation/'
} as const

export const ALL_ITEMS_PARAMS = {
  limit: 0,
  offset: 0
}
